/**
 * API client. Pass your own axios instance (with auth interceptors) or a base URL + token getter.
 *   createPortfolioHealthCheckApi({ axiosInstance })            // preferred: reuse your wrapper
 *   createPortfolioHealthCheckApi({ baseURL, getToken, axios })  // standalone
 * Every call resolves to `data` or throws an Error with .code / .status / .details from the server.
 */
export function createPortfolioHealthCheckApi({ axiosInstance, axios, baseURL = '', getToken, prefix = '/overlap-checker' } = {}) {
  const http = axiosInstance || (axios && axios.create({ baseURL }));
  if (!http) throw new Error('createPortfolioHealthCheckApi: pass axiosInstance or axios');
  async function post(path, body) {
    const headers = {};
    if (!axiosInstance && getToken) { const t = await getToken(); if (t) headers.Authorization = `Bearer ${t}`; }
    try {
      const res = await http.post(`${prefix}${path}`, body, { headers });
      if (!res.data || res.data.ok !== true) throw Object.assign(new Error('Unexpected response'), { code: 'bad_response' });
      return res.data.data;
    } catch (e) {
      const env = e && e.response && e.response.data && e.response.data.error;
      if (env) throw Object.assign(new Error(env.message), { code: env.code, status: e.response.status, details: env.details });
      if (e && e.code === 'bad_response') throw e;
      throw Object.assign(new Error('Could not reach the server. Check the connection and try again.'), { code: 'network' });
    }
  }
  return {
    holdingsSummary: (clientId, refresh = false, pan = undefined) =>
      post('/holdings-summary', {
        clientId,
        refresh,
        ...(pan ? { pan: String(pan).trim().toUpperCase() } : {}),
      }),
    searchSchemes: (clientId, reviewVersion, query) => post('/scheme-search', { clientId, reviewVersion, query }),
    updateReview: (clientId, reviewVersion, edits) => post('/review', { clientId, reviewVersion, edits }),
    analyse: (clientId, reviewVersion) => post('/analyse', { clientId, reviewVersion }),
    healthCheck: (clientId, reviewVersion, analysisId) => post('/health-check', { clientId, reviewVersion, analysisId }),
  };
}

export const inr = (x) => (x == null ? '—' : `₹${Math.round(x).toLocaleString('en-IN')}`);
export const pct = (x, d = 1) => (x == null ? '—' : `${(x * 100).toFixed(d)}%`);
